module.exports = __webpack_public_path__ + "img/cup3.a928df72.jpg";